import { useHistory, Redirect } from 'react-router-dom';
import { 
    IonContent, 
    IonPage,
    useIonAlert
} from '@ionic/react';

import { isMobile } from "react-device-detect";

import './LandingPage.css'


// Importing Page components
import Header from './components/Header';
import IntroSection from './components/IntroSection';
import HowSection from './components/HowSection';
import WhySection from './components/WhySection';
import FeaturesSection from './components/FeaturesSection';
import OneStopSection from './components/OneStopSection';
import FormSection from './components/FormSection';
import FAQSection from './components/FAQSection';
import DownloadRyde from './components/DownloadSection';
import Footer from './components/Footer';

const LandingPage = () => {
    
    const [present] = useIonAlert()
    const history = useHistory()

    // Check if it's mobile or desktop with useragent
    const checkMobile = () => {
        return (
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i) ||
            isMobile
        )
    }        
    var userDevice
    if(checkMobile()){
        userDevice = 'mobile'
    }
    else{
        userDevice = 'desktop'
    }

    return(
        <IonPage className='landing-page'>
            <IonContent>
                <>
                {Header(history)}
                {IntroSection(userDevice)}
                {HowSection(userDevice)}
                {WhySection(userDevice)}
                {FeaturesSection(userDevice)}
                {OneStopSection(history, userDevice)}
                {FormSection(present)}
                {FAQSection()}
                {DownloadRyde()}
                {Footer()}
                </>
            </IonContent>
        </IonPage>
    );
}

export default LandingPage;